/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
export default {
  name: 'home',
  components: {
    Navbar,
    ProductService,
    contactUs
  },
  data() {
    return {
      fixed: false,
      fromisActiveClass: 'contactUs',
      contractArr: [
        {
          imgUrl: require('../../../assets/images/contact/mobile.png'),
          title: '电话',
          desc: '010-62198995'
        },
        {
          imgUrl: require('../../../assets/images/contact/adress.png'),
          title: '地址',
          desc: '北京市海淀区杏石口路80号益园文创基地A区2号楼'
        },
        {
          imgUrl: require('../../../assets/images/contact/email.png'),
          title: '邮箱',
          desc: 'service@cacfintech.com'
        }
      ]
    };
  },
  created() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    handleScroll(){
      if(document.body.scrollHeight > window.innerHeight) {
        this.fixed = true;
      }
    },
    goHome() {
      this.$router.push({path: 'home'});
    }
  }
};
